import React from 'react';

const Footer = ({ basicInfo }) => {
    const Social = basicInfo.social.map((network) => {
        return (
            <span key={network.name} className="m-4">
                <a href={network.url} target="_blank" rel="noopener noreferrer">
                    <i className={network.class}></i>
                </a>
            </span>
        );
    });

    return (
        <footer>
            <div className="col-md-12">
                <div className="social-links">{Social}</div>
                <div className="mt-2 text-center">
                    <p>
                        Contact me:{'   '}
                        <a className="font-italic ml-3 text-decoration-none" href={'mailto:' + basicInfo.email}>
                            {basicInfo.email}
                        </a>
                    </p>
                </div>
                <div className="copyright py-4 text-center">
                    <div className="container">
                        <small>Copyright &copy; {basicInfo.name}</small>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
